import { DYNAMIC_CONFIG_NAMES, getConfig } from '@/lib/statsig';
import { Countries } from '@/types/Countries';

export const getFormerSignUpFee = (
  country: Countries,
  subscriptionCode?: string
) => {
  const config = getConfig(DYNAMIC_CONFIG_NAMES.formerSignUpFee, {
    custom: {
      country,
    },
  });
  return config.get<number | undefined>(subscriptionCode || '', undefined);
};
